import graphql from 'babel-plugin-relay/macro';

/**
 * Fragments
 */
export const SALES_ORDER_BASE_FRAGMENT = graphql`
  fragment salesOrderBaseFragment on SalesOrder {
    id
    externalRef
    accountId
    userId
    customerEmail
    customerFirstName
    customerLastName
    status
    meta
    eventRecurringId
    createdAt
    updatedAt
    deletedAt
  }
`;

export const SALES_ORDER_BASE_INLINE_FRAGMENT = graphql`
  fragment salesOrderBaseInlineFragment on SalesOrder @inline {
    id
    externalRef
    accountId
    userId
    customerEmail
    customerFirstName
    customerLastName
    status
    totalAmount
    grandAmount
    currencyCode
    meta
    eventRecurringId
    createdAt
    updatedAt
    deletedAt
    payment {
      ...paymentBaseInlineFragment
    }
  }
`;

export const SALES_ORDER_AMOUNT_FRAGMENT = graphql`
  fragment salesOrderAmountFragment on SalesOrder {
    subAmount
    taxAmount
    totalAmount
    discountAmount
    grandAmount
    currencyCode
    paymentTerms
  }
`;

export const SALES_ORDER_AMOUNT_INLINE_FRAGMENT = graphql`
  fragment salesOrderAmountInlineFragment on SalesOrder @inline {
    subAmount
    taxAmount
    totalAmount
    discountAmount
    grandAmount
    currencyCode
    paymentTerms
  }
`;

export const SALES_ORDER_PAYMENTS_FRAGMENT = graphql`
  fragment salesOrderPaymentsFragment on SalesOrder {
    paymentIns {
      amount
      createdAt
      currencyCode
      payerEmail
      externalRef
      salesOrder {
        id
        externalRef
      }
    }
  }
`;

export const SALES_ORDER_PAYMENTS_INLINE_FRAGMENT = graphql`
  fragment salesOrderPaymentsInlineFragment on SalesOrder @inline {
    paymentIns {
      amount
      createdAt
      currencyCode
      payerEmail
      externalRef
      salesOrder {
        id
        externalRef
      }
    }
  }
`;

export const SALES_ORDER_ITEM_INLINE_FRAGMENT = graphql`
  fragment salesOrderItemInlineFragment on SalesOrderItem @inline {
    id
    name
    description
    quantity
    price
    discount
    currencyCode
    meta
    product {
      ...productFragment
    }
  }
`;

export const SALES_ORDER_ITEM_FRAGMENT = graphql`
  fragment salesOrderItemFragment on SalesOrderItem {
    id
    name
    description
    quantity
    price
    discount
    currencyCode
    meta
    product {
      ...productFragment
    }
  }
`;

export const SALES_ORDER_INLINE_FRAGMENT = graphql`
  fragment salesOrderInlineFragment on SalesOrder @inline {
    ...salesOrderBaseInlineFragment
    ...salesOrderAmountInlineFragment
    ...salesOrderPaymentsInlineFragment
    salesOrderItems {
      ...salesOrderItemInlineFragment
    }
    paymentIns {
      ...paymentInInlineFragment
    }
    eventGuest {
      ...eventSalesOrderInlineFragment
    }
  }
`;

export const SALES_ORDER_FRAGMENT = graphql`
  fragment salesOrderFragment on SalesOrder {
    ...salesOrderBaseFragment
    ...salesOrderAmountFragment
    ...salesOrderPaymentsFragment

    salesOrderItems {
      ...salesOrderItemFragment
    }
  }
`;

/**
 * Pagination Fragments
 */
export const SALES_ORDERS_PAGINATION_FRAGMENT = graphql`
  fragment salesOrdersPaginationFragment on Query @refetchable(queryName: "SalesOrdersRefetchQuery") {
    salesOrders(first: $first, after: $after, filter: $filter, ordering: $ordering)
      @connection(key: "SalesOrdersPaginationFragement_salesOrders")
      @skip(if: $skip) {
      __id
      count
      edges {
        __id
        node {
          ...salesOrderBaseFragment
          ...salesOrderAmountFragment
          paymentIns {
            ...paymentInInlineFragment
          }
          eventGuest {
            ...eventSalesOrderFragment
          }
        }
      }
    }
  }
`;

/**
 * Queries
 */
export const SALES_ORDERS_PAGINATION_QUERY = graphql`
  query salesOrdersPaginationQuery(
    $first: Int!
    $after: String
    $ordering: [SalesOrderOrdering!]
    $filter: SalesOrderFilter
    $skip: Boolean!
  ) {
    ...salesOrdersPaginationFragment
  }
`;

export const SALES_ORDERS_QUERY = graphql`
  query salesOrdersQuery($first: Int!, $after: String, $ordering: [SalesOrderOrdering!], $filter: SalesOrderFilter) {
    salesOrders(first: $first, after: $after, ordering: $ordering, filter: $filter) {
      count
      edges {
        node {
          ...salesOrderInlineFragment
        }
      }
    }
  }
`;

export const SALES_ORDER_QUERY = graphql`
  query salesOrderQuery($id: ID!) {
    salesOrder(id: $id) {
      ...salesOrderFragment
    }
  }
`;

/**
 * Mutations
 */
export const SALES_ORDER_DELETE_MUTATION = graphql`
  mutation salesOrderDeleteMutation($ID: ID!, $connections: [ID!]!) {
    deleteSalesOrder(id: $ID) {
      id @deleteEdge(connections: $connections)
    }
  }
`;

export const SALES_ORDER_WITH_ITEMS_CREATE_MUTATION = graphql`
  mutation salesOrderWithItemsCreateMutation($input: CreateSalesOrderInput!) {
    createSalesOrderWithItems(input: $input)
  }
`;

export const SAlES_ORDER_UPDATE_MUTATION = graphql`
  mutation salesOrderUpdateMutation($id: ID!, $input: SalesOrderUpdateInput!) {
    updateSalesOrder(id: $id, input: $input) {
      salesOrder {
        ...salesOrderFragment
      }
    }
  }
`;

export const SALES_ORDER_SEND_PAYMENT_REQUEST_MUTATION = graphql`
  mutation salesOrderSendPaymentRequestMutation($input: SendPaymentRequestInput!) {
    sendPaymentRequest(input: $input) {
      success
    }
  }
`;
